// extracted by extract-css-chunks-webpack-plugin
module.exports = {"catalog-grid":"catalog-grid___yu7F9","card":"card___DZBj5"};